import type { SupportedLangs } from '@geartracker/types';

import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
export const AMPLITUDE_TUNNEL = 'https://amplitude.geartracker.net';

//Google
export const GOOGLE_WEB_CLIENT_ID =
  '660411064135-tddi8v8q2b8jlhmpaj47kigpuelidfs5.apps.googleusercontent.com'; //not a secret

//Apple
export const GOOGLE_IOS_CLIENT_ID =
  '660411064135-07rbbpqso1c8ah7dhaine74hesc3i0bk.apps.googleusercontent.com'; // not a secret

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
export const PATH_AFTER_REGISTER = paths.setup;

// Sentry
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
export const SENTRY_TUNNEL = 'https://sentry.geartracker.net';

// auth storage key
export const TOKEN_STORAGE_KEY = 'accessToken';
export const IMPERSONATION_TOKEN_STORAGE_KEY = 'impersonationToken';

// buckets
export const ASSETS_URL = import.meta.env.VITE_ASSETS_URL;
export const IMAGES_URL = import.meta.env.VITE_IMAGES_URL;

// share domain
export const SHARE_DOMAIN = 'https://g9r.org';

// Dev tooling
// Set VITE_DISABLE_QUERY_DEVTOOLS=true to hide the TanStack Query devtools badge locally
export const QUERY_DEVTOOLS_DISABLED =
  import.meta.env.VITE_DISABLE_QUERY_DEVTOOLS === 'true';

// App Store URLs
export const APP_STORE_URL_ANDROID =
  'https://play.google.com/store/apps/details?id=net.geartracker.app.twa';
export const APP_STORE_URL_IOS =
  'https://apps.apple.com/us/app/geartracker-manage-your-ppe/id6756706591';

// NFC tag shop, localized per language. Unlisted languages fall back to English.
export const NFC_SHOP_URLS: Record<SupportedLangs, string> = {
  fr: 'https://geartracker.net/fr/boutique/',
  en: 'https://geartracker.net/en/shop/',
  es: 'https://geartracker.net/es/tienda/',
  it: 'https://geartracker.net/it/negozio/',
  de: 'https://geartracker.net/de/geschaeft/',
};
export const NFC_SHOP_URL_DEFAULT = NFC_SHOP_URLS.en;
